<template>
  <v-layout wrap justify-left align-center>
    <v-dialog v-model="dialogConnection" persistent scrollable max-width="500px">
      <v-card style="max-width: 800px; max-height: 800px;">
        <v-card-title primary-title>
          <span v-if="connectionId === null" class="headline">{{translate('system.title.include') + translate('table.' + this.entity + '.title')[0]}}</span>
          <span v-if="connectionId !== null" class="headline">Vincular Cliente</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="valid" ref="form" @keyup.native.esc="close" @keyup.native.enter="customFilter()">
            <v-flex xs12>
              <v-autocomplete id="connectioncreated_connection_company_id" ref="autofocus" :label="translate('table.' + entity + '.field.connection_company_id')"
                                v-model="editedItem.connection_company_id" :items="companies" item-text="id_text" item-value="id" 
                                :rules="existRule(translate('table.' + entity + '.field.connection_company_id'),'connection_company_id', true, values)">
                <template slot='selection' slot-scope='{ item }'>
                  {{ item.id_text }} {{item.illis_name ? ('(' + item.illis_name + ')') : ''}}
                </template>
                <template slot='item' slot-scope='{ item }'>
                  {{ item.id_text }} {{item.illis_name ? ('(' + item.illis_name + ')') : ''}}
                </template>
              </v-autocomplete>
                <div v-if="editedItem.connection_company_id" class="dados animated zoomIn">
                  <div v-if="this.companies.find(a => a.id === editedItem.connection_company_id).logo_path" class="logo">
                    <img :src="`${basePath}uploads/companies/${this.companies.find(a => a.id === editedItem.connection_company_id).logo_path}`" alt="avatar">
                  </div>
                  <div v-else class="avatar">
                    <div class="icone">
                      <i class="fas fa-building"></i>
                    </div>
                  </div>
                  <div v-if="this.companies.find(a => a.id === editedItem.connection_company_id).bio">
                    <p style="font-weight: bold;">SOBRE NÓS</p> 
                    <p>{{this.companies.find(a => a.id === editedItem.connection_company_id).bio}}</p>      
                  </div>
                </div>   
            </v-flex>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="connectioncreated_save_btn" class="mx-0" color="primary darken-2" @click="connectionId ? editConnection() : save()">Enviar Convite</v-btn>
          <v-btn id="connectioncreated_close_btn" class="mx-0" @click="close">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style scoped>
  .dados{
    text-align: center;
  }

  .logo,
  .avatar{
    height: 200px;
    width: 200px;
    background: linear-gradient(to right, #00F260 , #0575E6);
    border-radius: 50%;
    margin: 0 auto;
    position: relative;
  }

  .dados img{
    width: 190px;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border: 2px solid #fff;
  }

  .dados .icone{
    font-size: 9em;
    color: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .dados p{
    font-size: 1.2em;
    margin-top: 10px;
    word-break: break-word;
  }
</style>

<script>
  import crud from '../../mixin/crud'
  import rules from '../../mixin/rules'

  export default {
    name: 'PConnectionCreated',
    mixins: [crud, rules],
    data: () => ({
      dialogConnection: false,
      connectionId: null,
      entity: 'connections',
      companies: [],
      basePath: process.env.API
    }),
    props: ['values'],
    created () {
      this.$http.get(`api/get_all_companies`).then(res => {
        this.companies = res.body.filter((val) => {
          return val.id !== this.$auth.user().company_id
        })
      })
    },
    methods: {
      beforeInsert () {
        let connectionCompany = this.companies.filter((val) => {
          return val.id === this.editedItem.connection_company_id
        })
        this.editedItem.active = true
        // type_person 2 = Pessoa Juridica
        // Status 1 = Aguardando resposta
        this.editedItem.status = 1
        // type 1 = Cliente
        this.editedItem.type = 1
        this.editedItem.id_text = `${connectionCompany[0].id_text} ${connectionCompany[0].illis_name ? '(' + connectionCompany[0].illis_name + ')' : ''}`
        this.editedItem.cpfcnpj = connectionCompany[0].cpfcnpj
        this.editedItem.type_person = connectionCompany[0].type_person
      },
      editConnection () {
        if (this.$refs.form && !this.$refs.form.validate()) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        this.editedItem.id = this.connectionId
        this.beforeInsert()
        this.$store.commit('loader/change_dialog', true)
        this.$http.post(`api/become_client`, this.editedItem).then((res) => {
          res.body.id_text = this.editedItem.id_text
          this.$emit('becomeConnected', res.body)
          this.$store.commit('loader/change_dialog', false)
          this.close()
        },
        er => {
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível enviar o convite', color: 'error', dialog: true
          })
        })
      },
      afterInsert (item) {
        this.$emit('saveItem', item)
      },
      openConnectionCreate (exist) {
        this.$refs.form.reset()
        this.$refs.form.resetValidation()
        this.dialogConnection = true
        this.view = 2
        // Se o registro já existe ele deve apenas ser editado e transformado em cliente
        this.connectionId = exist
      },
      close () {
        this.dialogConnection = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PConnectionCreated.vue